import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
export type FaqItem = {
  question: string;
  answer: string;
};
export function Faq({
  items
}: {
  items: FaqItem[];
}) {
  const [open, setOpen] = useState<number | null>(0);
  return <dl className="divide-y divide-mist-200 border-y border-mist-200" data-id="element-455" data-mp="1wm9ph0ocjn97">
      {items.map((item, i) => {
      const isOpen = open === i;
      return <div key={item.question} data-id="element-456" data-mp="13xm3f2vrwtul" data-mpi={i}>
            <dt data-id="element-457" data-mp="13ynbcyhht083">
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-458" data-mp="13z6uujmsjwo8">
                <span className="font-display text-base font-semibold text-graphite-900 md:text-lg" data-id="element-459" data-mp="1iuuvxzwtc3nw">{item.question}</span>
                <span className="mt-0.5 shrink-0 text-brand-600" data-id="element-460" data-mp="2p9vumdd82zy6">
                  {isOpen ? <MinusIcon className="h-5 w-5" aria-hidden="true" data-id="element-461" data-mp="2u7xcww2tqv8l" /> : <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-462" data-mp="2xqz29jffh48z" />}
                </span>
              </button>
            </dt>
            {isOpen && <dd className="max-w-3xl pb-6 text-sm leading-relaxed text-graphite-500 md:text-base" data-id="element-463" data-mp="2sse1niw9kik0">{item.answer}</dd>}
          </div>;
    })}
    </dl>;
}